import service from '../services'

export const TOGGLE_LOADING_STATUS = '@account/toggle-loading-status'
export const SET_GEOMETRY_DATA = '@account/set-geometry-data'
export const SET_VIEW_TYPE = '@account/set-view-type'
export const GET_GEOJSON_DATA = '@account/get-geoJson-data'
export const SET_UNIT_DATA = '@account/set-unit-data'
export const SET_UNIT_WITH_DETAILS = '@account/set-unit-with-details'
export const GET_UNITS_LIST = '@account/get-units-list'
export const GET_UNITS_BY_BUILDING = '@account/get-units-by-building'
export const GET_UNITS_EXCLUDING_BUILDING = '@account/get-units-excluding-building'
export const GET_BUILDINGS_LIST = '@account/get-buildings-list'
export const SET_PAGE = '@account/set-page'
export const SET_FILTERS = '@account/set-filters'
export const SET_FEATURE = '@account/set-feature'
export const SET_COLOR_MODE = '@account/set-color-mode'
export const SET_UNIT_TYPE_SCREEN = '@account/set-unit-type-screen'

export function setGeometryData (payload) {
  return async (dispatch) => {
    // eslint-disable-next-line no-useless-catch
    try {
      dispatch({
        type: SET_GEOMETRY_DATA,
        payload
      })
    } catch (error) {
      console.error(error)
      throw error
    }
  }
}

export function getUnitData (id) {
  return async (dispatch) => {
    // eslint-disable-next-line no-useless-catch
    try {
      const response = await service.getUnit(id)
      await dispatch({
        type: SET_UNIT_DATA,
        payload: response.data
      })
    } catch (error) {
      console.error(error)
      throw error
    }
  }
}
export function setUnitData (payload) {
  return async (dispatch) => {
    // eslint-disable-next-line no-useless-catch
    try {
      dispatch({
        type: SET_UNIT_DATA,
        payload
      })
    } catch (error) {
      console.error(error)
      throw error
    }
  }
}

export function getUnits (payload) {
  return async (dispatch) => {
    try {
      dispatch({
        type: TOGGLE_LOADING_STATUS,
        status: true
      })
      const response = await service.getUnits(payload)
      await dispatch({
        type: GET_UNITS_LIST,
        payload: response.data
      })
      await dispatch({
        type: TOGGLE_LOADING_STATUS,
        status: false
      })
    } catch (error) {
      dispatch({
        type: GET_UNITS_LIST,
        payload: []
      })
      dispatch({
        type: TOGGLE_LOADING_STATUS,
        status: false
      })
      throw error
    }
  }
}
export function setUnits (payload) {
  return async (dispatch) => {
    dispatch({
      type: GET_UNITS_LIST,
      payload
    })
  }
}
export function getUnitsExcludingBuildingFilter (payload) {
  return async (dispatch) => {
    try {
      const filters = { ...payload }
      delete filters.building
      filters.max = 500
      delete filters.page
      const response = await service.getUnits(filters)
      await dispatch({
        type: GET_UNITS_EXCLUDING_BUILDING,
        payload: response.data
      })
    } catch (error) {
      dispatch({
        type: GET_UNITS_EXCLUDING_BUILDING,
        payload: []
      })
      throw error
    }
  }
}

export function getUnitWithDetails (id) {
  return async (dispatch) => {
    // eslint-disable-next-line no-useless-catch
    try {
      dispatch({
        type: TOGGLE_LOADING_STATUS,
        status: true
      })
      const response = await service.getUnitWithDetails(id)
      await dispatch({
        type: SET_UNIT_WITH_DETAILS,
        payload: response.data
      })
      await dispatch({
        type: TOGGLE_LOADING_STATUS,
        status: false
      })
    } catch (error) {
      console.error(error)
      throw error
    }
  }
}
export function setUnitWithDetails (payload) {
  return async (dispatch) => {
    dispatch({
      type: SET_UNIT_WITH_DETAILS,
      payload
    })
  }
}

export function getBuildings () {
  return async (dispatch) => {
    try {
      dispatch({
        type: TOGGLE_LOADING_STATUS,
        status: true
      })
      const response = await service.getBuilding()
      await dispatch({
        type: GET_BUILDINGS_LIST,
        payload: response.data
      })
      await dispatch({
        type: TOGGLE_LOADING_STATUS,
        status: false
      })
    } catch (error) {
      dispatch({
        type: GET_BUILDINGS_LIST,
        payload: []
      })
      dispatch({
        type: TOGGLE_LOADING_STATUS,
        status: false
      })
      throw error
    }
  }
}
export function getGeoJson (id) {
  return async (dispatch) => {
    try {
      dispatch({
        type: TOGGLE_LOADING_STATUS,
        status: true
      })
      const response = await service.getGeoJson(id)
      await dispatch({
        type: GET_GEOJSON_DATA,
        payload: response.data
      })
      await dispatch({
        type: TOGGLE_LOADING_STATUS,
        status: false
      })
    } catch (error) {
      dispatch({
        type: TOGGLE_LOADING_STATUS,
        status: false
      })
      dispatch({
        type: GET_GEOJSON_DATA,
        payload: {}
      })
      console.error(error)
      throw error
    }
  }
}

export function setViewType (payload) {
  return async (dispatch) => {
    // eslint-disable-next-line no-useless-catch
    try {
      dispatch({
        type: SET_VIEW_TYPE,
        payload
      })
    } catch (error) {
      console.error(error)
      throw error
    }
  }
}
export function setUnitTypeScreen (payload) {
  return async (dispatch) => {
    // eslint-disable-next-line no-useless-catch
    try {
      dispatch({
        type: SET_UNIT_TYPE_SCREEN,
        payload
      })
    } catch (error) {
      console.error(error)
      throw error
    }
  }
}
export function setFeature (payload) {
  return async (dispatch) => {
    // eslint-disable-next-line no-useless-catch
    try {
      dispatch({
        type: SET_FEATURE,
        payload
      })
    } catch (error) {
      console.error(error)
      throw error
    }
  }
}
export function setColorMode (mode) {
  return async (dispatch) => {
    dispatch({
      type: SET_COLOR_MODE,
      mode
    })
  }
}
export function setPage (index) {
  return async (dispatch) => {
    dispatch({
      type: SET_PAGE,
      payload: index
    })
  }
}
export function setFilters (payload) {
  return async (dispatch) => {
    dispatch({
      type: SET_FILTERS,
      payload
    })
  }
}
